import { render, staticRenderFns } from "./takingsOverviewSummaryBox.vue?vue&type=template&id=c2ae91ac&"
import script from "./takingsOverviewSummaryBox.vue?vue&type=script&lang=ts&"
export * from "./takingsOverviewSummaryBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports